import { render, staticRenderFns } from "./platticketpick.vue?vue&type=template&id=96669874&"
import script from "./platticketpick.vue?vue&type=script&lang=js&"
export * from "./platticketpick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports